import React from 'react';
import { Grid, Button, IconButton } from '@mui/material';
import * as Icon from '@mui/icons-material';

interface ServicosTableProps {
  values: any;
  handleOpenPecasModal: () => void;
  setFieldValue: any;
  duploClick?: boolean;
  edicaoRestrita: boolean;
}

const OrdemServicoServicos: React.FC<ServicosTableProps> = ({ values, handleOpenPecasModal: handleOpenServicoModal, setFieldValue, duploClick, edicaoRestrita }) => {

  const handleRemoveServico = (index: number) => {
    const updatedServicoJson = values.servicosjson.filter((_: any, i: any) => i !== index);
    setFieldValue('servicosjson', updatedServicoJson);
  };

  const handleEditItem = (index: number) => {
    const selectedServico = values.servicosjson[index];
    setFieldValue('selectedServico', selectedServico);
    handleOpenServicoModal();
  };
  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '80%', margin: '0 auto' }}
    >
      <Grid item xs={12}>
        <fieldset disabled={duploClick || edicaoRestrita}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleOpenServicoModal}
            sx={{ mb: 2 }}
          >
            Adicionar Item
          </Button>
        </fieldset>
      </Grid>
      <Grid item xs={12}>
        <fieldset disabled={duploClick || edicaoRestrita}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Servico</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Quantidade</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Valor</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Desconto</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Valor Total</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {values.servicosjson.map((item: any, index: any) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.servico?.produto}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.servico?.quantidade}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.servico?.valorUnitario}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.servico?.desconto}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.servico?.valorTotal}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                    <IconButton disabled={duploClick || edicaoRestrita} onClick={() => handleEditItem(index)} aria-label='edit' color='info' title='Editar'>
                      {' '}
                      <Icon.Edit />
                    </IconButton>
                    <IconButton color='error' onClick={() => handleRemoveServico(index)} disabled={duploClick || edicaoRestrita}>
                      <Icon.Delete />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </Grid>
    </Grid>
  );
}

export default OrdemServicoServicos;